<template>
  <div class="equipment-control">
    <water-quality v-for="item in data.sensorEquipments" :sensorData="item" :key="item.id" @clearAlame="clearAlame"></water-quality>
    <remote-control v-for="item in data.switchEquipments" :switchData="item" :key="item.id + 1" @clearAlame="clearAlame"></remote-control>
    <div v-if="data && data.sensorEquipments && data.sensorEquipments.length === 1 && (!data.switchEquipments || !data.switchEquipments.length)">
      <div class="chart-time-container" style="margin:35px auto">
        <span class="demonstration">时间</span>
        <el-date-picker v-model="startTime" :clearable="false" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions" placeholder="开始日期">
        </el-date-picker>
        <span class="spr-line"></span>
        <el-date-picker v-model="endTime" :clearable="false" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions" placeholder="结束日期">
        </el-date-picker>
        <el-button class="loadChartBtn" type="primary" @click="loadChartData">查询</el-button>
      </div>
      <div class="charts-container">
        <sensor-chart v-if="data.sensorEquipments[0].sensors && data.sensorEquipments[0].sensors.length" ref="sensorChart1" class="sensorChart"
          :sensorArry="data.sensorEquipments[0].sensors" :equipmentId="data.sensorEquipments[0].id" :index="0" :startTime="startTime" :endTime="endTime" />
        <sensor-chart v-if="data.sensorEquipments[0].sensors && data.sensorEquipments[0].sensors.length > 2" ref="sensorChart2" class="sensorChart"
          :sensorArry="data.sensorEquipments[0].sensors" :equipmentId="data.sensorEquipments[0].id" :index="1" :startTime="startTime" :endTime="endTime" />
      </div>
    </div>
    <!-- 警告声音 -->
    <audio ref="warm" loop="-1" preload="auto" muted controls="controls" id="music">
      <source :src="require('../../../public/warning.mp3')" />
    </audio>
  </div>
</template>

<script>
import WaterQuality from '@/components/v2/WaterQuality.vue'
import RemoteControl from '@/components/v2/RemoteControl.vue'
import SensorChart from '@/components/v3/sensorChart'
import equipmentV2 from '../../store/modules/equipmentV2'
import { mapState, mapActions, mapMutations } from 'vuex'
import mixins from '@/assets/js/mixins.js'
export default {
  name: 'EquipmentControl',
  mixins: [mixins],
  components: {
    WaterQuality,
    RemoteControl,
    SensorChart
  },
  data () {
    return {
      data: {},
      startTime: '',
      endTime: ``,
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      timer: null,
      second: 0,
      clearAvoice: 1800 // 半小时后警报声响
    }
  },
  watch: {
    equipmentData: {
      handler (value) {
        console.log(value, '???')
        this.data = value
        this.checkAlame(value)
      }
      // immediate: true
    },
    basic: {
      handler (value) {
        if (value) {
          this.setActiveTitle(value.title)
        }
      },
      immediate: true
    },
    startTime (newValue) {
      const momentStart = this.$Moment(newValue, 'YYYY-MM-DD')
      const momentEnd = this.$Moment(this.endTime, 'YYYY-MM-DD')
      const diffDays = Math.abs(momentEnd.diff(momentStart, 'days'))
      if (diffDays > 4) {
        this.endTime = `${momentStart.add(4, 'days').format('YYYY-MM-DD')}`
      }
    },
    endTime (newValue) {
      const momentStart = this.$Moment(this.startTime, 'YYYY-MM-DD')
      const momentEnd = this.$Moment(newValue, 'YYYY-MM-DD')
      const diffDays = Math.abs(momentEnd.diff(momentStart, 'days'))
      if (diffDays > 4) {
        this.startTime = `${momentEnd.add(-4, 'days').format('YYYY-MM-DD')}`
      }
    }
  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData', 'basic', 'currentEnterprise'])
  },
  async mounted () {
    function pagePc () {
      let rootValue = 100
      let pc = rootValue / 1920 // 表示1366的设计图,使用100px的默认值
      let width = window.innerWidth // 当前窗口的宽度
      let height = window.innerHeight // 当前窗口的高度
      let rem = ''
      let currentHeight = (width * 798) / 1920
      if (height < currentHeight) {
        // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        width = (height * 1920) / 798
      }
      rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    }

    pagePc()
    window.onresize = function () {
      pagePc()
    }
    // 获取当前数据
    let obj = JSON.parse(localStorage.getItem('currentBasic'))
    if (obj) {
      await this.getEquipmentsData(obj)
      this.setChooseBasic(obj)
    }

    this.startTime = `${this.$Moment().format('YYYY-MM-DD')}`// '2022-07-19' // `${this.$Moment().format('YYYY-MM-DD')}`,
    this.endTime = `${this.$Moment().format('YYYY-MM-DD')}`
    this.$nextTick(() => {
      this.loadChartData()
    })
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentsData']),
    ...mapMutations(equipmentV2, ['setActiveTitle', 'setChooseBasic']),
    // 检查是否有警告值
    checkAlame (data) {
      let sensorAlarm
      let switchAlarm
      if (data.sensorEquipments) {
        sensorAlarm = data.sensorEquipments.some((item) => {
          if (item.alarmMessageList !== null) {
            return item.alarmMessageList.length > 0
          }
        })
      }
      if (data.switchEquipments) {
        switchAlarm = data.switchEquipments.some((item) => {
          if (item.alarmMessageList !== null) {
            return item.alarmMessageList.length > 0
          }
        })
      }
      // 水质和远程 某个有报警值  且 second为0 时 报警
      if ((sensorAlarm || switchAlarm) && this.second === 0) {
        this.playVoice()
      } else {
        clearInterval(this.timer)
        let audio = this.$refs.warm
        setTimeout(() => {
          audio.pause()
        }, 0)
      }
    },
    // 播放声音
    playVoice () {
      this.$nextTick(() => {
        let audio = this.$refs.warm
        setTimeout(() => {
          if (audio.paused) {
            // 判读是否播放
            // audio.paused=false;
            audio.play() // 没有就播放
          }
        }, 0)
      })
    },
    // 清除警报声
    clearAlame () {
      let audio = this.$refs.warm
      audio.pause()
      this.second = this.clearAvoice
      this.timer = setInterval(() => {
        --this.second
        if (this.second <= 0) {
          this.second = 0
          this.checkAlame(this.data)
          clearInterval(this.timer)
        }
      }, 1000)
    },

    loadChartData () {
      if (this.$refs.sensorChart1) {
        this.$refs.sensorChart1.getData()
      }
      if (this.$refs.sensorChart2) {
        this.$refs.sensorChart2.getData()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    let audio = this.$refs.warm
    setTimeout(() => {
      audio.pause()
    }, 0)
  }
}
</script>

<style lang="scss">
.equipment-control {
  height: calc(100vh - 0.65rem);
  padding-bottom: 0.3rem;
  overflow: auto;
  .chart-time-container {
    .demonstration {
      display: inline-block;
      width: 50px;
      margin-left: 10px;
      font-size: 14px;
      text-align: center;
      color: #bbd4e9;
    }
    .el-input {
      width: 156px;
      input {
        border: 1px solid #07f;
        color: #fff;
        background: none;
      }
    }
    .spr-line {
      display: inline-block;
      width: 12px;
      text-align: center;
      background: #07f;
      height: 1px;
      line-height: 40px;
      vertical-align: middle;
      margin-right: 10px;
      margin-left: 10px;
    }

    .loadChartBtn {
      margin-left: 15px;
    }
  }

  .charts-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .sensorChart {
      width: 50%;
    }
  }
}
audio {
  width: 0px;
  height: 0px;
}
</style>
